import { render } from "./aianalyst.vue?vue&type=template&id=5e777a96&scoped=true"
import script from "./aianalyst.vue?vue&type=script&lang=js"
export * from "./aianalyst.vue?vue&type=script&lang=js"

import "./aianalyst.vue?vue&type=style&index=0&id=5e777a96&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e777a96"]])

export default __exports__